import axios from 'axios'

export const state = {
  oncallDuties: null,
}

export const getters = {
  oncallDuties: (state) => state.oncallDuties,
}

export const mutations = {
  SET_ONCALL_DUTIES(state, oncallDuties) {
    state.oncallDuties = oncallDuties
  },
}

export const actions = {
  fetchAllOncallDuties({ commit, state, rootState }, payload) {
    return axios
      .get('/api/oncall_duties', {
        params: payload,
      })
      .then((response) => {
        const oncallDuties = response.data
        commit('SET_ONCALL_DUTIES', oncallDuties)
        return oncallDuties
      })
  },

  createOncallDuty({ commit, state, rootState }, payload) {
    return axios.post('/api/oncall_duties', payload)
  },

  deleteOncallDuty({ commit, state, rootState }, payload) {
    return axios.delete(`/api/oncall_duties/${payload.id}`)
  },
}
